export const UserCompaniesColumnNames = {
  Email: "Email",
  Companies: "Companies",
  Details: "Details"
};
